import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {BatteryService} from '../../../services/battery.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import {BatteryReplacementActionTypes} from '../../index';
import {catchError, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {of} from 'rxjs';
import {BtyReplacementParams} from '../battery-replacement.model';



@Injectable()
export class BatteryReplacementEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private batteryService = inject(BatteryService);

  constructor() {}

  getBatteryReplacementLog$ = createEffect(() => this.actions$.pipe(
    ofType(BatteryReplacementActionTypes.GetBatteryReplacements),
    map((action: featureActions.GetBatteryReplacements) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([actionPayload, user]) => {
      const payload = { ...(actionPayload ?? {}) };
      const params: BtyReplacementParams = {
        otp: user.otp,
        acode: payload.acode,
      };
      if (!payload.getAll && !payload.acode) { // Only get specific acode data.
        params.acode = user.acode;
      }
      if (payload.dcode) {
        params.dcode = payload.dcode;
      }
      if (payload.RegionIds) {
        params.RegionIds = Array.isArray(payload.RegionIds) ? [...payload.RegionIds] : payload.RegionIds;
      }
      return this.batteryService.GetBatteryReplacementLog(params).pipe(
        map((res: any) => {
          if (res.result && Array.isArray(res.msg.data)) {
            return new featureActions.UpsertBatteryReplacements({batteryReplacements: res.msg.data});
            } else {
            return new featureActions.GetBatteryReplacementFails();
            }
          }
        ),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetBatteryReplacementFails());
        })
      );
    })
  ));
}
